import React, { useState, useEffect } from 'react';
import { Layout, Menu, Button, Avatar, Dropdown, message, Tag } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  DashboardOutlined,
  ShoppingOutlined,
  TagsOutlined,
  AppstoreOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  CrownOutlined,
  TeamOutlined,
  TagOutlined,
  MessageOutlined,
  TruckOutlined,
  GlobalOutlined,
  DollarOutlined,
  AccountBookOutlined,
  CarOutlined,
} from '@ant-design/icons';
import { authAPI } from '../api';

const { Header, Sider, Content } = Layout;

const AdminLayout = ({ children, onLogout, selectedKey, onMenuSelect }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [userInfo, setUserInfo] = useState(null);

  // 根据当前路径确定选中的菜单项
  const getCurrentSelectedKey = () => {
    const path = location.pathname;
    if (path.includes('/dashboard')) return 'dashboard';
    if (path.includes('/products')) return 'products';
    if (path.includes('/categories')) return 'categories';
    if (path.includes('/collections')) return 'collections';
    if (path.includes('/customizations')) return 'customizations';
    if (path.includes('/support-tickets')) return 'support-tickets';
    if (path.includes('/special-prices')) return 'special-prices';
    if (path.includes('/orders')) return 'orders';
    if (path.includes('/financial')) return 'financial';
    if (path.includes('/freight')) return 'freight';
    if (path.includes('/shipping-companies')) return 'shipping-companies';
    if (path.includes('/exchange-rates')) return 'exchange-rates';
    if (path.includes('/users')) return 'users';
    return selectedKey || 'dashboard';
  };

  useEffect(() => {
    fetchUserInfo();
  }, []);

  const fetchUserInfo = async () => {
    try {
      const response = await authAPI.getProfile();
      setUserInfo(response.data);
    } catch (error) {
      message.error('获取用户信息失败');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    onLogout();
    message.success('退出登录成功');
  };

  const handleMenuClick = ({ key }) => {
    // 根据菜单key导航到对应路由
    switch (key) {
      case 'dashboard':
        navigate('/admin/dashboard');
        break;
      case 'products':
        navigate('/admin/products');
        break;
      case 'categories':
        navigate('/admin/categories');
        break;
      case 'collections':
        navigate('/admin/collections');
        break;
      case 'customizations':
        navigate('/admin/customizations');
        break;
      case 'support-tickets':
        navigate('/admin/support-tickets');
        break;
      case 'special-prices':
        navigate('/admin/special-prices');
        break;
      case 'orders':
        navigate('/admin/orders');
        break;
      case 'financial':
        navigate('/admin/financial');
        break;
      case 'freight':
        navigate('/admin/freight');
        break;
      case 'shipping-companies':
        navigate('/admin/shipping-companies');
        break;
      case 'exchange-rates':
        navigate('/admin/exchange-rates');
        break;
      case 'users':
        navigate('/admin/users');
        break;
      default:
        break;
    }
    // 同时调用原有的回调（如果存在）
    if (onMenuSelect) {
      onMenuSelect(key);
    }
  };

  const userMenu = {
    items: [
      {
        key: 'profile',
        icon: <UserOutlined />,
        label: '个人资料',
      },
      {
        type: 'divider',
      },
      {
        key: 'logout',
        icon: <LogoutOutlined />,
        label: '退出登录',
        onClick: handleLogout,
      },
    ],
  };

  const menuItems = [
    {
      key: 'dashboard',
      icon: <DashboardOutlined />,
      label: '概览',
    },
    {
      key: 'products',
      icon: <ShoppingOutlined />,
      label: '商品管理',
    },
    {
      key: 'categories',
      icon: <TagsOutlined />,
      label: '分类管理',
    },
    {
      key: 'collections',
      icon: <AppstoreOutlined />,
      label: '商品集管理',
    },
    {
      key: 'customizations',
      icon: <TagOutlined />,
      label: '定制需求',
    },
    {
      key: 'support-tickets',
      icon: <MessageOutlined />,
      label: '支持工单',
    },
    {
      key: 'special-prices',
      icon: <DollarOutlined />,
      label: '按用户报价',
    },
    {
      key: 'orders',
      icon: <ShoppingCartOutlined />,
      label: '订单管理',
    },
    {
      key: 'financial',
      icon: <AccountBookOutlined />,
      label: '财务管理',
    },
    {
      key: 'freight',
      icon: <TruckOutlined />,
      label: '运费模板',
    },
    {
      key: 'shipping-companies',
      icon: <CarOutlined />,
      label: '物流公司管理',
    },
    {
      key: 'exchange-rates',
      icon: <GlobalOutlined />,
      label: '汇率管理',
    },
    {
      key: 'users',
      icon: <TeamOutlined />,
      label: '用户管理',
    },
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider 
        trigger={null} 
        collapsible 
        collapsed={collapsed}
        style={{
          boxShadow: '2px 0 8px rgba(0,0,0,0.1)',
        }}
      >
        <div style={{ 
          height: 32, 
          margin: 16, 
          background: 'rgba(255, 255, 255, 0.2)',
          borderRadius: 6,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontWeight: 'bold',
          fontSize: collapsed ? '14px' : '16px',
          cursor: 'pointer'
        }}
        onClick={() => navigate('/')}
        >
          {collapsed ? '管理' : 'FAFA Demo'}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[getCurrentSelectedKey()]}
          items={menuItems}
          onClick={handleMenuClick}
        />
      </Sider>
      <Layout>
        <Header style={{ 
          padding: '0 16px', 
          background: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: '16px',
              width: 64,
              height: 64,
            }}
          />
          <Dropdown menu={userMenu} placement="bottomRight">
            <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
              <Avatar icon={<UserOutlined />} style={{ marginRight: 8 }} />
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span>{userInfo?.username || 'Admin'}</span>
                <Tag color="#ff4d4f" icon={<CrownOutlined />}>
                  Admin
                </Tag>
              </div>
            </div>
          </Dropdown>
        </Header>
        <Content style={{ 
          margin: '16px',
          padding: '24px',
          background: '#fff',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}>
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
